import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import GroupedCell from './GroupedCell';
import AggregateCell from './AggregateCell';
import ExpandedRow from './ExpandedRow';

const CustomBody = ({ page, prepareRow, columns }) =>
  page.map((row) => {
    prepareRow(row);
    return (
      <TableRow {...row.getRowProps()}>
        {row.isExpanded ? (
          <ExpandedRow row={row} columns={columns} />
        ) : (
          row.cells.map((cell) => (
            <TableCell {...cell.getCellProps()}>
              {cell.isGrouped ? (
                <GroupedCell cell={cell} row={row} />
              ) : (
                <AggregateCell cell={cell} />
              )}
            </TableCell>
          ))
        )}
      </TableRow>
    );
  });

export default CustomBody;
